const ROUTES = {
    MORTGAGE_PANEL: '/myprofile/mortgage/panel',
    MORTGAGE_LANDING: '/myprofile/loans-mortgages',
    INSURANCES_LANDING: '/myprofile/insurances',
    INSURANCES_HOME_REQUEST: '/myprofile/insurances/home/request',
    INSURANCES_RELATED: '/myprofile/mortgage/insurances-related',
};

module.exports = ROUTES;
